module.exports = __webpack_public_path__ + "flyer_image_overlay_rotating_shapes_008-0b08cf7e029d2ebdb68c849851af2352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_rotating_shapes_008.png
// module id = 1569
// module chunks = 1